import { render, staticRenderFns } from "./interesse-klein.vue?vue&type=template&id=42eb495a&"
import script from "./interesse-klein.vue?vue&type=script&lang=js&"
export * from "./interesse-klein.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports